// extracted by mini-css-extract-plugin
module.exports = {"stepper":"onboarding-steps_stepper__3pmsP","missingDetailMessage":"onboarding-steps_missingDetailMessage__1U32J"};